<template>
  <div class="bg-gray-200 flex content-between gap-4 content-start">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </div>
</template>

<style scoped>
</style>